/**
 * Maps Windows timezone names to IANA timezone identifiers
 */
export const WINDOWS_TIMEZONE_MAP: { [key: string]: string } = {
  'Central Standard Time': 'America/Chicago',
  'Pacific Standard Time': 'America/Los_Angeles',
  'Eastern Standard Time': 'America/New_York',
  'Mountain Standard Time': 'America/Denver',
  'Alaska Standard Time': 'America/Anchorage',
  'Hawaii Standard Time': 'Pacific/Honolulu',
  'GMT Standard Time': 'Europe/London',
  'Central European Standard Time': 'Europe/Berlin',
  'Tokyo Standard Time': 'Asia/Tokyo',
  'China Standard Time': 'Asia/Shanghai',
  'India Standard Time': 'Asia/Kolkata',
  'Arabian Standard Time': 'Asia/Dubai',
  UTC: 'UTC',
};

/**
 * Maps descriptive Windows timezone formats to IANA timezone identifiers
 * Handles format: "(UTC-06:00) Central Time (US & Canada)"
 */
export const DESCRIPTIVE_TIMEZONE_MAP: { [key: string]: string } = {
  'Central Time (US & Canada)': 'America/Chicago',
  'Pacific Time (US & Canada)': 'America/Los_Angeles',
  'Eastern Time (US & Canada)': 'America/New_York',
  'Mountain Time (US & Canada)': 'America/Denver',
  Alaska: 'America/Anchorage',
  Hawaii: 'Pacific/Honolulu',
  'Greenwich Mean Time : Dublin, Edinburgh, Lisbon, London': 'Europe/London',
  'Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna': 'Europe/Berlin',
  'Tokyo, Osaka, Sapporo': 'Asia/Tokyo',
  'Beijing, Chongqing, Hong Kong, Urumqi': 'Asia/Shanghai',
  'Chennai, Kolkata, Mumbai, New Delhi': 'Asia/Kolkata',
  'Abu Dhabi, Muscat': 'Asia/Dubai',
  'Coordinated Universal Time': 'UTC',
};

/**
 * Error conditions used to determine user notification severity
 * Status messages containing these keywords are classified as errors
 */
export const USER_ERROR_CONDITIONS = [
  'unknown',
  'bad', // Bad Item
  'exception', // Read Registers exception
  'fail', // OpenPort failed, Socket Connect failed, SocketConnectFail, GetOpCode_6 failed
  'null',
  'error', // Error, CRCError
  'commandnotsupported',
  'rpcservunvl',
  'timeout', // Timeout, COMTimeout
  'illegal', // illegal data address
];
